export default __webpack_public_path__ + "static/OYOY-1280x260-30fps-59df859e1938f69f4ce2caf76ace98b8.mp4";